import module from 'nominas/nomina/module.js'
import { noop, orderBy } from 'lodash'

export class NominaCalculoService {
  colaboradores = null
  configuracion = null
  catalogo = {
    conceptos: [],
    impuestos: [],
    imssImpuestos: [],
    subsidios: [],
    diasVacaciones: [],
  }
  loader = null
  script = null
  onProgress = noop
  onError = noop
  onComplete = noop
  completados = []
  progreso = 0
  completado = false
  resultado = null
  calculando = false

  constructor ($http, $q, $window, $worker, NominasNominaCalculoConceptos, CatalogoImpuestos, CatalogoImssImpuestos, CatalogoSubsidios, CatalogoDiasVacaciones) {
    this.$http = $http
    this.$q = $q
    this.$window = $window
    this.$worker = $worker
    this.NominasNominaCalculoConceptos = NominasNominaCalculoConceptos
    this.CatalogoImpuestos = CatalogoImpuestos
    this.CatalogoImssImpuestos = CatalogoImssImpuestos
    this.CatalogoSubsidios = CatalogoSubsidios
    this.CatalogoDiasVacaciones = CatalogoDiasVacaciones
  }

  iniciar () {
    this.loader = this.$q.defer()

    let promise = this.$q.all([
        this.obtenerScript(),
        this.obtenerCatalogoConceptos(),
        this.obtenerCatalogoImpuestos(),
        this.obtenerCatalogoImssImpuestos(),
        this.obtenerCatalogoSubsidios(),
        this.obtenerCatalogoDiasVacaciones(),
      ])
      .then(() => (this.loader.resolve()))

    this.$q.all([promise, this.loader.promise])
      .then(() => (this.calcular()))
      .catch(({data}) => (this.onError(data)))
  }

  calcular () {
    this.calculando = true
    this.pendientes = [...this.colaboradores]
    this.worker = new this.$worker(this.script)
    this.worker.onmessage(({data}) => (this.postSuccess(data)))
    this.worker.onerror(({message}) => (this.postError(message)))

    this.siguiente()
  }

  cancelar () {
    this.loader.reject()
    this.terminar()
  }

  postSuccess ({colaborador, error = null}) {
    if (error) {
      this.postError(error)

      return
    }

    this.completados.push(colaborador)

    this.progreso = this.completados.length / this.colaboradores.length
    this.completado = this.completados.length === this.colaboradores.length

    this.onProgress(colaborador)

    if (this.completado) {
      this.resultado = [...this.completados]
      this.terminar()
      this.onComplete(this.resultado)
    } else {
      this.siguiente()
    }
  }

  postError (error) {
    this.error = `Error: ${error}`
    this.terminar()
    this.onError(error)
  }

  siguiente () {
    const indice = this.colaboradores.length - this.pendientes.length
    const colaborador = this.pendientes.shift()
    this.worker.postMessage({
      indice,
      colaborador,
      configuracion: this.configuracion,
      conceptos: this.catalogo.conceptos,
      impuestos: this.catalogo.impuestos,
      subsidios: this.catalogo.subsidios,
      imssImpuestos: this.catalogo.imssImpuestos,
      diasVacaiones: this.catalogo.diasVacaciones,
    })
  }

  terminar () {
    this.calculando = false

    if (this.worker) {
      this.worker.terminate()
      this.worker = null
    }

    if (this.script) {
      this.$window.URL.revokeObjectURL(this.script)
      this.script = null
    }
  }

  obtenerScript () {
    return this.$http.get('/api/nominas/calculo/script', {responseType: 'blob'})
      .then(({data}) => (this.script = this.$window.URL.createObjectURL(data)))
  }

  obtenerCatalogoConceptos () {
    const config = {
      id_proyecto: this.colaboradores[0].id_empresa,
      tipo_calculo_id: this.configuracion.tipo_calculo_id,
    }

    return this.NominasNominaCalculoConceptos.get(config)
      .then(({data}) => (this.catalogo.conceptos = orderBy(data.conceptos, ['orden', 'id'])))
  }

  obtenerCatalogoImpuestos () {
    return this.CatalogoImpuestos.get()
      .then(({data}) => (this.catalogo.impuestos = data))
  }

  obtenerCatalogoImssImpuestos () {
    return this.CatalogoImssImpuestos.get()
      .then(({data}) => (this.catalogo.imssImpuestos = data))
  }

  obtenerCatalogoSubsidios () {
    return this.CatalogoSubsidios.get({id_tipo_nomina: this.configuracion.tarifa})
      .then(({data}) => (this.catalogo.subsidios = data))
  }

  obtenerCatalogoDiasVacaciones () {
    if (this.configuracion.id_tipo_nomina !== 6) return this.$q.resolve()

    return this.CatalogoDiasVacaciones.get()
      .then(({data}) => (this.catalogo.diasVacaciones = data))
  }
}

module.factory('NominaCalculoFactory', ($http, $q, $window, $worker, NominasNominaCalculoConceptos, CatalogoImpuestos, CatalogoImssImpuestos, CatalogoSubsidios, CatalogoDiasVacaciones) => {
  return (colaboradores, configuracion) => {
    const servicio = new NominaCalculoService($http, $q, $window, $worker, NominasNominaCalculoConceptos, CatalogoImpuestos, CatalogoImssImpuestos, CatalogoSubsidios, CatalogoDiasVacaciones)
    servicio.colaboradores = colaboradores
    servicio.configuracion = configuracion

    return servicio
  }
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/factories/Nomina/Calculo.js